<template>
    <div class="main">
        <div class="menu">
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect"
                background-color="rgb(250, 250, 250)">
                <el-menu-item index="1">样品监控系统</el-menu-item>
            </el-menu>
        </div>
        <div class="sample1_select_menu">
            <el-button icon="el-icon-refresh" @click="init" :loading="isSending">获取列表</el-button>
            <el-input placeholder="请输入(sku + 品名)" v-model="skuInput"
                style="margin-left: 10px; width: 200px;"></el-input>
            <el-button type="success" @click="save" :loading="isSendingSingleSku"
                style="margin-left: 5px;">单样品创建</el-button>
            <el-button icon="el-icon-plus" @click="insert" style="margin-left: 10px;">添加新样品监控</el-button>
            <el-select v-model="creatorFilter" placeholder="筛选创建人" clearable style="margin-left: 15px; width: 140px;">
                <el-option v-for="item in uniqueCreators" :key="item" :label="item" :value="item"></el-option>
            </el-select>
            <el-select v-model="statusFilter" placeholder="筛选状态" clearable style="margin-left: 10px; width: 140px;">
                <el-option v-for="item in uniqueStatuses" :key="item" :label="item" :value="item"></el-option>
            </el-select>
            <el-input placeholder="请输入SKU" prefix-icon="el-icon-search" v-model="select_input"
                style="float: right; width: 200px; margin-left: 20px;">
            </el-input>
            <el-button @click="select_m" :loading="isSending8" style="float: right; margin-left: 5px;">搜索</el-button>
        </div>
        <div class="sample1">
            <div class="sample1_div1">
                <div class="sample1_table1">
                    <el-table :data="filteredTableData.slice((currentPage - 1) * pageSize, currentPage * pageSize)"
                        style="width: 100%" height="100%" stripe border
                        :header-cell-style="{ background: '#f5f7fa', color: '#606266', fontWeight: '600' }"
                        :cell-style="{ padding: '8px 0' }">
                        <el-table-column type="index" label="#" width="50" align="center">
                        </el-table-column>
                        <el-table-column prop="SKU" label="SKU" min-width="80" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column prop="品名" label="品名" min-width="200" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column prop="创建人" label="创建人" width="180" align="center">
                        </el-table-column>
                        <el-table-column prop="状态" label="状态" width="120" align="center">
                            <template slot-scope="scope">
                                <el-tag :type="getStatusTagType(scope.row.状态)" size="small" effect="light">
                                    {{ scope.row.状态 }}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="创建时间" label="创建时间" width="160" align="center">
                        </el-table-column>
                        <el-table-column prop="修改时间" label="修改时间" width="160" align="center">
                        </el-table-column>
                        <el-table-column label="操作" width="100" align="center">
                            <template slot-scope="scope">
                                <el-popconfirm title="确认删除吗？" @confirm="delete_sample(scope.row)">
                                    <el-button size="mini" plain type="danger" slot="reference">删除</el-button>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="pagination-wrapper">
                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                            :current-page="currentPage" :page-sizes="[20, 50, 100]" :page-size="pageSize"
                            layout="total, sizes, prev, pager, next, jumper" :total="filteredTableData.length">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog :title="title" :visible="dialogVisible" width="50%" :before-close="handleClose">
            <el-tabs v-model="dialogTab" type="border-card">
                <el-tab-pane label="文件导入" name="file">
                    <el-form :model="form" status-icon :rules="rules" ref="form" label-width="100px" label-position="left">
                        <el-form-item label="文件操作">
                            <div style="display: flex; justify-content: space-between; width: 100%">
                                <div style="width: 60%">
                                    <el-upload class="upload-demo" ref="upload" action="" :auto-upload="false"
                                        :on-change="handleFileChange" :file-list="fileList" accept=".xlsx,.xls,.csv" :limit="1">
                                        <el-button slot="trigger" size="large" type="primary">选择文件</el-button>
                                        <div slot="tip" class="el-upload__tip">只能上传xlsx/xls/csv文件，且不超过10MB</div>
                                    </el-upload>
                                </div>
                                <div style="width: 35%; text-align: right">
                                    <el-button type="primary" @click="downloadTemplate" :loading="isDownloading">
                                        下载导入模板
                                    </el-button>
                                </div>
                            </div>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>
                <el-tab-pane label="PO批量同步" name="poSync">
                    <div v-loading="isSendingPoBatch"
                         element-loading-text="正在同步PO数据，请耐心等待..."
                         element-loading-spinner="el-icon-loading"
                         element-loading-background="rgba(255, 255, 255, 0.85)"
                         style="min-height: 120px;">
                        <div style="padding: 10px 0;">
                            <div style="margin-bottom: 16px;">
                                <span style="color: #909399; font-size: 13px;">请输入PO号，多个用英文逗号（,）分隔，不支持中文逗号</span>
                            </div>
                            <el-input
                                type="textarea"
                                v-model="poInput"
                                :rows="10"
                                placeholder="请输入PO号，格式如：PO260706001,PO260706002,PO260706003"
                                :disabled="isSendingPoBatch">
                            </el-input>
                            <div style="margin-top: 10px; display: flex; justify-content: space-between; align-items: center;">
                                <div>
                                    <span style="color: #909399; font-size: 13px;">PO数量：</span>
                                    <span style="color: #409EFF; font-weight: bold; font-size: 16px;">{{ poCount }}</span>
                                </div>
                                <el-tag v-if="hasChineseComma" type="danger" size="medium">
                                    检测到中文逗号，请使用英文逗号（,）分隔
                                </el-tag>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button v-if="dialogTab === 'file'" type="primary" @click="uploadFile" :loading="isSending_i">提交</el-button>
                <el-button v-if="dialogTab === 'poSync'" type="primary" @click="submitPoBatch" :loading="isSendingPoBatch" :disabled="hasChineseComma || poCount === 0">提交</el-button>
            </span>
        </el-dialog>

        <el-dialog :title="title" :visible="dialogVisible1" width="30%" :before-close="handleClose1">
            <el-form :model="form" status-icon :rules="rules" ref="form" label-width="100px" label-position="left">
                <el-form-item label="MSKU" prop="MSKU">
                    <!-- <el-input v-model="form.lv" autocomplete="off" /> -->
                    <el-input v-model="form.MSKU" autocomplete="off" style="width: 47%;" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="店铺" prop="店铺">
                    <!-- <el-input v-model="form.lv" autocomplete="off" /> -->
                    <el-input v-model="form.店铺" autocomplete="off" style="width: 47%;" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="最低价格" prop="最低价格">
                    <!-- <el-input v-model="form.lv" autocomplete="off" /> -->
                    <el-input v-model="form.最低价格" autocomplete="off" style="width: 47%;"
                        placeholder="请填写最低价格"></el-input>
                </el-form-item>
                <el-form-item label="最高价格" prop="最高价格">
                    <!-- <el-input v-model="form.lv" autocomplete="off" /> -->
                    <el-input v-model="form.最高价格" autocomplete="off" style="width: 47%;"
                        placeholder="请填写最高价格"></el-input>
                </el-form-item>
                <el-form-item label="评论下限" prop="评论下限">
                    <!-- <el-input v-model="form.lv" autocomplete="off" /> -->
                    <el-input v-model="form.评论下限" autocomplete="off" style="width: 47%;"
                        placeholder="请填写评论下限"></el-input>
                </el-form-item>
                <el-form-item label="评论上限" prop="评论上限">
                    <!-- <el-input v-model="form.lv" autocomplete="off" /> -->
                    <el-input v-model="form.评论上限" autocomplete="off" style="width: 47%;"
                        placeholder="请填写评论上限"></el-input>
                </el-form-item>
                <!-- <el-form-item label="是否被占用" prop="是否被占用">
                    <el-select v-model="form.QA" multiple placeholder="请选择流量分析">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item> -->
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="reset">重置</el-button>
                <el-button type="primary" @click="update" :loading="isSending_u">修改</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            input: '',
            table: false,
            activeIndex: '1',
            activeIndex2: '1',
            bottercold: '',
            select_input: '',
            select_type: '',
            isSending: false,
            isSending2: false,
            isSending3: false,
            isSending8: false,
            isSending9: false,
            isSending10: false,
            isSending_i: false,
            isSending_danger: false,
            isSending_u: false,
            dialogVisible: false,
            form: {},
            size: '',
            title: '',
            visible: false,
            tableuse: [],
            tableData: [],
            tableDataover: [],
            options: [{ value: 'CoBak-US', label: 'CoBak-US' }, { value: 'CoBak-UK', label: 'CoBak-UK' }, { value: 'CoBak-SG', label: 'CoBak-SG' }, { value: 'CoBak-SE', label: 'CoBak-SE' }, { value: 'CoBak-PL', label: 'CoBak-PL' }, { value: 'CoBak-NL', label: 'CoBak-NL' }, { value: 'CoBak-MX', label: 'CoBak-MX' }, { value: 'CoBak-JP', label: 'CoBak-JP' }, { value: 'CoBak-IT', label: 'CoBak-IT' }, { value: 'CoBak-INDIA-IN', label: 'CoBak-INDIA-IN' }, { value: 'CoBak-FR', label: 'CoBak-FR' }, { value: 'CoBak-ES', label: 'CoBak-ES' }, { value: 'CoBak-DE', label: 'CoBak-DE' }, { value: 'CoBak-CA', label: 'CoBak-CA' }, { value: 'CoBak-BR', label: 'CoBak-BR' }, { value: 'CoBak Direct-BE', label: 'CoBak Direct-BE' }, { value: 'SMIFACE-CA', label: 'SMIFACE-CA' }, { value: 'SMIFACE-US', label: 'SMIFACE-US' }, { value: 'IDLEHANDS-US-CA', label: 'IDLEHANDS-US-CA' }, { value: 'iDLEHANDS-US-MX', label: 'iDLEHANDS-US-MX' }, { value: 'iDLEHANDS-US-US', label: 'iDLEHANDS-US-US' }],
            value1: [],
            value2: [],
            value3: [],
            sortField: '',
            sortOrder: '',
            formLabelWidth: '80px',
            timer: null,
            sxsx: '',
            shop: {},
            currentPage: 1,
            pageSize: 20,
            select_n: 0,
            fileList: [],
            skuInput: '',
            creatorFilter: '',
            statusFilter: '',
            isDownloading: false,
            dialogTab: 'file',
            poInput: '',
            isSendingPoBatch: false,
            // 添加表单验证规则
            rules: {
                file: [
                    { required: true, message: '请上传文件', trigger: 'blur' }
                ]
            }
        }
    },
    created() {
        this.init()
    },
    computed: {
        uniqueCreators() {
            const creators = this.tableData.map(item => item.创建人).filter(Boolean);
            return [...new Set(creators)];
        },
        uniqueStatuses() {
            const statuses = this.tableData.map(item => item.状态).filter(Boolean);
            return [...new Set(statuses)];
        },
        filteredTableData() {
            return this.tableData.filter(item => {
                const matchCreator = !this.creatorFilter || item.创建人 === this.creatorFilter;
                const matchStatus = !this.statusFilter || item.状态 === this.statusFilter;
                return matchCreator && matchStatus;
            });
        },
        poCount() {
            if (!this.poInput || !this.poInput.trim()) return 0;
            const items = this.poInput.split(',').filter(item => item.trim() !== '');
            return items.length;
        },
        hasChineseComma() {
            return this.poInput.includes('，');
        }
    },
    watch: {
        creatorFilter() {
            this.currentPage = 1;
        },
        statusFilter() {
            this.currentPage = 1;
        }
    },
    methods: {
        getStatusTagType(status) {
            const map = {
                '已给样品': 'success',
                '已完成': 'success',
                '进行中': '',
                '待处理': 'warning',
                '异常': 'danger',
            };
            return map[status] || 'info';
        },
        // @size-change页码展示数量点击事件
        handleSizeChange(val) {
            // 更新每页展示数据size
            this.pageSize = val
        },
        // @current-change页码点击事件
        handleCurrentChange(val) {
            // 更新当前页数是第几页
            this.currentPage = val
        },
        init() {
            this.isSending = true;
            this.$axios.get('/vue/sample/sample_all')
                .then(res => {
                    console.log(res);
                    this.tableData = res.data.reverse();
                    this.isSending = false;
                })
                .catch(error => {  // 这里应该是 .catch，而不是 .console
                    console.log(error);
                    this.isSending = false;
                });
        },
        select_m() {
            this.isSending8 = true
            this.$axios.post('/vue/sample/select_sample', { input: this.select_input }).then(res => {
                console.log(res);
                this.tableData = res.data
                this.currentPage = 1;
                this.isSending8 = false
            })
                .console(error => {
                    console.log(error)
                    this.isSending8 = false
                })
        },
        handleSelect(key, keyPath) {
            console.log(key, keyPath);
        },
        add() {
            this.dialogVisible = true
            this.title = '创建项目'
            this.form = {}
        },
        insert() {
            this.form = {}
            this.title = '新增监控'
            this.dialogTab = 'file'
            this.poInput = ''
            this.fileList = []
            this.dialogVisible = true
        },
        handleButtonClick(row) {
            this.form = {}
            this.title = '编辑监控'
            this.form = row
            this.form.MSKU = row.MSKU
            this.form.店铺 = row.店铺
            this.form.最低价格 = row.最低价格
            this.form.最高价格 = row.最高价格
            this.form.评论上限 = row.评论上限
            this.form.评论下限 = row.评论下限
            this.dialogVisible1 = true
        },
        sample_review() {
            this.$axios.get('/vue/sample/sample_review').then(res => {
                console.log(res);
                this.tableuse = res.data

            })
                .console(error => {
                    console.log(error)
                })
        },
        handleClose() {
            this.dialogVisible = false
            this.dialogTab = 'file'
            this.poInput = ''
            this.init()
        },
        handleClose1() {
            this.dialogVisible1 = false
            this.init()
        },
        sample_danger(row) {
            this.isSending_danger = true
            this.$axios.post('/vue/sample/sample_danger', row).then(res => {
                if (res.code == 200) {
                    let _this = this
                    this.isSending_danger = false
                    this.$notify.success({
                        title: '成功',
                        message: res.msg,
                        duration: 2000,
                        onClose: function () { _this.handleClose1() }
                    });
                } else {
                    this.isSending_danger = false
                    this.$notify.error({
                        title: '错误',
                        message: res.msg,
                        duration: 2000
                    });
                }
            }).catch(error => {
                console.log(error)
                alert('发生错误:==' + '请检查内容是否填写完整')
                this.isSending = false
            })
        },
        delete_sample(row) {
            this.isSending = true
            this.$axios.post(`/vue/sample/delete_sample`, row).then(res => {
                if (res.code == 200) {
                    let _this = this
                    this.$notify.success({
                        title: '成功',
                        message: res.msg,
                        duration: 2000,
                        onClose: function () { _this.handleClose() }
                    });
                    this.isSending = false
                } else {
                    this.$notify.error({
                        title: '错误',
                        message: res.msg,
                        duration: 2000
                    });
                    this.isSending = false
                }
            }).catch(error => {
                console.log(error)
                alert('发生错误' + error)
                this.isSending = false
            })
        },
        sample_success(row) {
            this.isSending_success = true
            this.$axios.post('/vue/sample/sample_success', row).then(res => {
                if (res.code == 200) {
                    let _this = this
                    this.isSending_success = false
                    this.$notify.success({
                        title: '成功',
                        message: res.msg,
                        duration: 2000,
                        onClose: function () { _this.handleClose1() }
                    });
                } else {
                    this.isSending_success = false
                    this.$notify.error({
                        title: '错误',
                        message: res.msg,
                        duration: 2000
                    });
                }
            }).catch(error => {
                console.log(error)
                alert('发生错误:==')
                this.isSending_success = false
            })
        },
        // 下载模板方法
        downloadTemplate() {
            this.isDownloading = true;

            this.$axios.get('/vue/sample/downloadTemplate')
                .then(response => {
                    // 1. 严格验证响应结构
                    if (!response.data) {
                        throw new Error('响应缺少data字段');
                    }

                    // 2. 移除Base64字符串中的干扰字符
                    const base64Data = response.data
                        .replace(/\s/g, '') // 移除所有空白字符
                        .trim();

                    // 3. Base64解码（兼容方案）
                    const binaryString = atob(base64Data);
                    const bytes = new Uint8Array(binaryString.length);
                    for (let i = 0; i < binaryString.length; i++) {
                        bytes[i] = binaryString.charCodeAt(i);
                    }

                    // 4. 创建Blob并下载
                    const blob = new Blob([bytes], {
                        type: response.mimeType
                    });
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = response.filename;
                    link.style.display = 'none';
                    document.body.appendChild(link);
                    link.click();

                    // 5. 延迟清理
                    setTimeout(() => {
                        document.body.removeChild(link);
                        URL.revokeObjectURL(url);
                        this.isDownloading = false;
                    }, 300);
                })
                .catch(error => {
                    console.error('完整错误:', error);
                    this.$message.error(
                        error.response?.data?.msg ||
                        error.message ||
                        '下载失败'
                    );
                    this.isDownloading = false;
                });
        },

        // 文件选择变化处理
        handleFileChange(file, fileList) {
            // 限制文件大小
            const isLt10M = file.size / 1024 / 1024 < 10;
            if (!isLt10M) {
                this.$message.error('上传文件大小不能超过10MB!');
                return false;
            }
            this.fileList = fileList.slice(-1); // 只保留最新上传的文件
            this.form.file = file.raw; // 将文件对象保存到form中
        },

        // 上传文件方法
        async uploadFile() {
            // 1. 验证文件有效性
            if (!this.fileList || this.fileList.length === 0) {
                this.$message.error('请先选择文件');
                return;
            }

            const file = this.fileList[0].raw; // Element UI文件在.raw中
            if (!(file instanceof File)) {
                this.$message.error('无效的文件对象');
                return;
            }

            this.isSending_i = true;

            // 2. 转换为Base64（兼容二进制安全传输）
            const fileBase64 = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result.split(',')[1]); // 去除data:前缀
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });

            // 3. 构建结构化数据
            const uploadData = {
                file: fileBase64,
                metaData: {
                    originalName: file.name,
                    uploadTime: new Date().toISOString(),
                    fileType: file.type
                }
            };

            // 4. 创建FormData
            const formData = new FormData();
            formData.append(
                'upload',
                new Blob([JSON.stringify(uploadData)], { type: 'application/json' }),
                file.name
            );

            // 5. 发送请求
            const response = await this.$axios.post('/vue/sample/uploadSampleFile', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
                withCredentials: true
            });
            if (response.code == 200) {
                this.$message.success(response.msg || '上传成功');
                this.dialogVisible = false;
                this.init(); // 刷新表格

                // 重置为初始状态
                this.fileList = [];
                this.form = {};
                this.isSending_i = false;
            } else {
                this.isSending_i = false;
            }
        },
        save() {
            if (!this.skuInput) {
                this.$message.error('请输入SKU');
                return;
            }
            this.isSendingSingleSku = true;
            this.$axios.post('/vue/sample/sample_data_insert', { input: this.skuInput }).then(res => {
                if (res.code == 200) {
                    this.$message.success(res.msg || '创建成功');
                    this.init(); // 刷新列表
                    this.skuInput = '';
                } else {
                    this.$message.error(res.msg || '创建失败');
                }
                this.isSendingSingleSku = false;
            }).catch(error => {
                console.log(error);
                this.$message.error('创建失败: ' + (error.response?.data?.msg || error.message));
                this.isSendingSingleSku = false;
            });
        },
        onPoInputChange() {
            // 实时校验：移除中文逗号时自动替换提示
        },
        submitPoBatch() {
            if (!this.poInput || !this.poInput.trim()) {
                this.$message.error('请输入PO号');
                return;
            }
            if (this.hasChineseComma) {
                this.$message.error('检测到中文逗号，请使用英文逗号（,）分隔');
                return;
            }
            this.isSendingPoBatch = true;
            const poNumbers = this.poInput.split(',')
                .map(item => item.trim())
                .filter(item => item !== '');
            this.$axios.post('/vue/sample/sample_po_batch', { poNumbers: poNumbers }, { timeout: 300000 }).then(res => {
                if (res.code == 200) {
                    const stats = res.stats || {};
                    const msg = res.msg || 'PO批量同步成功';
                    this.$message({
                        type: 'success',
                        message: msg,
                        duration: 5000,
                        showClose: true
                    });
                    this.dialogVisible = false;
                    this.poInput = '';
                    this.dialogTab = 'file';
                    this.init();
                } else {
                    const invalidPos = res.invalidPos || [];
                    let errMsg = res.msg || 'PO批量同步失败';
                    if (invalidPos.length > 0) {
                        errMsg = `以下 ${invalidPos.length} 个PO号格式不正确:\n${invalidPos.join('\n')}`;
                    }
                    this.$message({
                        type: 'error',
                        message: errMsg,
                        duration: 8000,
                        showClose: true,
                        dangerouslyUseHTMLString: false
                    });
                }
                this.isSendingPoBatch = false;
            }).catch(error => {
                console.log(error);
                const errData = error.response?.data || {};
                const invalidPos = errData.invalidPos || [];
                let errMsg = errData.msg || error.message;
                if (invalidPos.length > 0) {
                    errMsg = `以下 ${invalidPos.length} 个PO号格式不正确:\n${invalidPos.join('\n')}`;
                }
                this.$message({
                    type: 'error',
                    message: '同步失败: ' + errMsg,
                    duration: 8000,
                    showClose: true
                });
                this.isSendingPoBatch = false;
            });
        },
        update() {
            this.isSending_u = true
            console.log(this.form);
            this.$axios.post(`/vue/sample/sample_data_update`, this.form).then(res => {
                if (res.code == 200) {
                    let _this = this
                    this.$notify.success({
                        title: '成功',
                        message: res.msg,
                        duration: 2000,
                        onClose: function () { _this.handleClose1() }
                    });
                    this.isSending_u = false
                } else {
                    this.$notify.error({
                        title: '错误',
                        message: res.msg,
                        duration: 2000
                    });
                    this.isSending_u = false
                }
            }).catch(error => {
                console.log(error)
                alert('请检查是否填写完整' + error)
                this.isSending_u = false
            })
        },
    }
}
</script>

<style>
.main {
    height: 100%;
    width: 100%;
    background-color: #f0f2f5;
}

.sample1_select_menu {
    width: 100%;
    height: 8.5%;
    background-color: #fff;
    padding: 8px 16px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
}

.sample1 {
    height: 88.9%;
    padding: 12px 16px;
    box-sizing: border-box;
}

.sample1_div1 {
    width: 100%;
    height: 100%;
}

.sample1_table1 {
    width: 100%;
    background: #fff;
    border-radius: 4px;
    height: 92%;
    padding: 12px;
    box-sizing: border-box;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

.pagination-wrapper {
    padding: 12px 0 0 0;
    text-align: right;
}
</style>

<style scoped="scoped">
::v-deep .warm tbody tr>td {
    background-color: rgba(236, 236, 236, 0.8);
}
</style>